/**
 * @component ActionsSection
 * @description
 * Componente que renderiza las acciones disponibles en la parte superior derecha de la tabla.
 * Muestra un botón de filtro en pantallas pequeñas, y dependiendo si hay filas seleccionadas,
 * muestra `BulkActions` (acciones masivas) o `CollegesTableActions` (botón para nuevo colegio).
 *
 * @param {Object} selectedRowIds - Objeto con los IDs de las filas seleccionadas en la tabla.
 * @param {Function} handleShow - Función que se ejecuta al hacer clic en el botón de filtro.
 * @param {Function} handleOpen - Función que se ejecuta al hacer clic en el botón "Nuevo".
 *
 * @example
 * <ActionsSection
 *     selectedRowIds={selectedRows}
 *     handleShow={handleFilter}
 *     handleOpen={handleOpenModal}
 * />
 */

import React from 'react';

import BulkActions from './BulkActions';
import CollegesTableActions from './CollegesTableActions';

const ActionsSection = ({ selectedRowIds, handleOpen }) => (
    <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        {/* Mostrar acciones masivas si hay filas seleccionadas */}
        {Object.keys(selectedRowIds).length > 0 ? (
            <BulkActions />
        ) : (
            <CollegesTableActions handleOpen={handleOpen} />
        )}
    </div>
);

export default ActionsSection;